import React from "react";
import { confirmDialog } from "primereact/confirmdialog";
import { Info, AlertTriangle } from "lucide-react";

export function confirmDanger(message: string, header: string, onAccept: () => void) {
    confirmDialog({
        message,
        header,
        icon: React.createElement(Info, { size: 24, className: "text-danger-500" }),
        rejectClassName: "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium bg-white border border-neutral-300 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-50 dark:hover:bg-neutral-700 transition-all duration-200 !bg-white !text-neutral-700 !border-neutral-300 dark:!bg-neutral-800 dark:!text-neutral-300 dark:!border-neutral-700",
        accept: onAccept,
        reject: () => { },
    });
}

export function confirmAction(message: string, header: string, onAccept: () => void) {
    confirmDialog({
        message,
        header,
        icon: React.createElement(AlertTriangle, { size: 24, className: "text-warning-500" }),

        rejectClassName: "inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium bg-white border border-neutral-300 text-neutral-700 dark:bg-neutral-800 dark:text-neutral-300 dark:border-neutral-700 hover:bg-neutral-50 dark:hover:bg-neutral-700 transition-all duration-200 !bg-white !text-neutral-700 !border-neutral-300 dark:!bg-neutral-800 dark:!text-neutral-300 dark:!border-neutral-700",
        accept: onAccept,
        reject: () => { },
    });
}
